import script from "./check-payroll-audit-report.vue?vue&type=script&setup=true&lang=js"
export * from "./check-payroll-audit-report.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__